import React from 'react';
import { Checkbox, Modal, Table } from 'rsuite';
import './showdimm.css'

const ShowDimensionModal = ({ showDimm, handleCloseDimm, selectedRow, finShow, label, handleToggle = (x) => { } }) => {
    // console.log('selectedRow',selectedRow);
    return (
        <Modal open={showDimm} onClose={handleCloseDimm} size="sm">
            <Modal.Header>
                <Modal.Title><b> Dimension</b> </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Table data={selectedRow} height={400} wordWrap bordered>
                    {selectedRow && selectedRow[0].status && <Table.Column align='center' width={80}>
                        <Table.HeaderCell>Select</Table.HeaderCell>
                        <Table.Cell >
                            {(rowData,rowindex) => (
                                <Checkbox
                                    inline
                                    checked={rowData.status}
                                    onChange={() => handleToggle(rowindex)}
                                    style={{ marginLeft: '-5px' }}  
                                />
                            )}
                        </Table.Cell>
                    </Table.Column>}
                    <Table.Column align='center' width={150}>
                        <Table.HeaderCell>Part Desc.</Table.HeaderCell>
                        <Table.Cell dataKey="Description" />
                    </Table.Column>

                    <Table.Column align='center' width={200}>
                        <Table.HeaderCell>Size</Table.HeaderCell>
                        <Table.Cell>
                            {rowData => {
                                return `${rowData.Length}x${rowData.Width}x${rowData.Height} ${rowData.SizeUnit}`;
                            }}
                        </Table.Cell>
                    </Table.Column>

                    <Table.Column align='center' width={100}>
                        <Table.HeaderCell>{label[0]?.attributes.color}</Table.HeaderCell>
                        <Table.Cell dataKey="ColorName" />
                    </Table.Column>

                    <Table.Column align='center' width={100}>
                        <Table.HeaderCell>{label[0]?.attributes.NetWgt}</Table.HeaderCell>
                        <Table.Cell dataKey="NetWt" />
                    </Table.Column>
                    {finShow && (
                        <>
                            <Table.Column align='center' width={100}>
                                <Table.HeaderCell>Finish</Table.HeaderCell>
                                <Table.Cell dataKey="FinishName" />
                            </Table.Column>

                            <Table.Column align='center' width={200}>
                                <Table.HeaderCell>Mat. Name</Table.HeaderCell>
                                <Table.Cell dataKey="MatName" />
                            </Table.Column>
                            <Table.Column align='center' width={100}>
                                <Table.HeaderCell>{'SetRate'}</Table.HeaderCell>
                                <Table.Cell dataKey="SetRate" />
                            </Table.Column>
                        </>
                    )}
                </Table>
            </Modal.Body>
        </Modal>
    );
}

export default ShowDimensionModal;